// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__2JaXU","title":"Text_title__3waSO"};